'use client';

import React, { FC } from 'react';

import Warranty from 'components/commercetools-ui/organisms/warranty';

const WarrantyTastic:FC<any> = ({ data }) => {
  return <Warranty warranty={data?.data?.dataSource} />;
};

export default WarrantyTastic;
